export default __webpack_public_path__ + "static/media/Brill_40_Racing_L.b6933754.png";